import { Color } from '@persona-id/design-tokens';
import { StarFillIcon } from '@persona-id/design-tokens/icons/12px';
import styled from 'styled-components';

import Sticker from 'design-system/components/Sticker';
import { assertNever } from 'lib/utils/types';

const StickerWrapper = styled.div`
  display: flex;
  margin-top: auto;
  margin-bottom: auto;
  cursor: default;
  svg {
    height: auto;
  }
`;

export enum EnhancedGatingStickerType {
  Enhanced = 'Enhanced',
  Limited = 'Limited',
}

const InquiriesGatingSticker = ({
  dataMarketingIdSuffix,
  stickerType,
  iconOnly,
}: {
  dataMarketingIdSuffix?: string;
  stickerType: EnhancedGatingStickerType;
  iconOnly?: boolean;
}) => {
  switch (stickerType) {
    case EnhancedGatingStickerType.Enhanced:
      return (
        <StickerWrapper data-marketing-id={`inquiries-enhanced-badge__${dataMarketingIdSuffix}`}>
          <Sticker
            variant='primary'
            icon={<StarFillIcon color={Color.PrimaryBlack} />}
            aria-label='Inquiries Enhanced sticker'
          >
            {!iconOnly ? 'Enhanced' : null}
          </Sticker>
        </StickerWrapper>
      );
    case EnhancedGatingStickerType.Limited:
      return (
        <StickerWrapper data-marketing-id={`inquiries-limited-badge__${dataMarketingIdSuffix}`}>
          <Sticker
            variant='teal'
            icon={<StarFillIcon color={Color.PrimaryBlack} />}
            aria-label='Inquiries Limited sticker'
          >
            {!iconOnly ? 'Limited' : null}
          </Sticker>
        </StickerWrapper>
      );
    default:
      assertNever(stickerType as never);
  }
};

export default InquiriesGatingSticker;
